import type { Ticker } from '../store/heatmapStore';

const TAB_BRAND = 'Meridian View AI';

export function formatBrowserTabTitle(ticker: Ticker, spotPrice: number | null): string {
  if (spotPrice == null) {
    return `${ticker} | ${TAB_BRAND}`;
  }

  return `${ticker} $${formatSpotPriceForTitle(spotPrice)} | ${TAB_BRAND}`;
}

function formatSpotPriceForTitle(spotPrice: number): string {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(spotPrice);
}
